import { Directive, ElementRef, NgZone, Renderer2, ContentChild, OnInit } from '@angular/core';

@Directive({
  selector: '[draggable]'
})
export class DragDirective implements OnInit {
  @ContentChild('display', {static:false}) display!: ElementRef;

  constructor(
    private _el: ElementRef,
    private _zone: NgZone,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    this._zone.runOutsideAngular(() => {
      this._el.nativeElement.addEventListener(
        'drop', this.onDrop.bind(this)
      );
      this._el.nativeElement.addEventListener(
        'dragend', this.onDragEnd.bind(this)
      );
      this._el.nativeElement.addEventListener(
        'dragover', this.onDragOver.bind(this)
      );
      this._el.nativeElement.addEventListener(
        'dragenter', this.onDragEnter.bind(this)
      );
      this._el.nativeElement.addEventListener(
        'dragleave', this.onDragLeave.bind(this)
      );
    });
  }

  onDrop(){
    this.renderer.addClass(this.display.nativeElement, 'ondrop')
    setTimeout(() => {
      this.renderer.removeClass(this.display.nativeElement, 'ondragover')
    },1500);
  }
  
  onDragOver(){
      this.renderer.removeClass(this.display.nativeElement, 'ondragleave')
      this.renderer.addClass(this.display.nativeElement, 'ondragover')
 

  }

  onDragLeave(){
    this.renderer.removeClass(this.display.nativeElement, 'ondragover')
    this.renderer.addClass(this.display.nativeElement, 'ondragleave')
  }

  onDragEnter(){
    // this.renderer.addClass(this._el.nativeElement, 'ondragover')
  }

  onDragEnd(){
    // this.renderer.addClass(this._el, 'ondragover')
  }
}
